<template>
  <span
      v-tooltip="showTooltip && tooltipText ? tooltipOptions : null"
      :class="['badge d-flex', tagBgColor]"
      style="max-width:100%"
  >
    <div class="tag-text-wrapper text-truncate d-inline-block">
      <slot>{{ title }}</slot>
    </div>
    <span
        v-if="!noRemove"
        class="remove-button bi bi-x"
        @click="$emit('remove')"
    />
  </span>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    noRemove: Boolean,
    title: String,
    description: String,
    showTooltip: Boolean,
    tagBgColor: String,
    useTitleForTooltip: Boolean
  },
  computed: {
    tooltipText() {
      return this.useTitleForTooltip ? this.title : this.description;
    },
    tooltipOptions() {
      return {
        text: this.tooltipText,
        theme: {
          color: '#fff',
          placement: 'top',
          backgroundColor: '#000000'
        },
        trigger: 'hover',
        delay: { show: 150 }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.remove-button {
  margin-right: -6px;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }
}

.badge {
  margin: 2px;
  cursor: pointer;
}
</style>